import { deadlineMinutes } from 'config'
import dayjs from 'dayjs'

export const getDeadline = (deadline = deadlineMinutes) => {
  return dayjs()
    .minute(dayjs().minute() + deadline)
    .valueOf()
}

export const getDeadlineInSeconds = (deadlineMin: number) => Math.floor(getDeadline(deadlineMin) / 1000)
